import * as React from 'react';
import type { JSX } from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import * as styles from './BuilderCallReasons.css';
import { Layout } from '../Layout';

const QUESTIONS = [
  'Какие есть варианты отделки?',
  'Есть акции и скидки?',
  'С каким банками работаете?',
  'Может, на других этажах есть квартиры дешевле?',
  'Когда сдаётся дом?',
];

export interface IBuilderCallReasonsProps {
  contactsButton: JSX.Element;
  flatViewOrderButton: JSX.Element;
}

export const BuilderCallReasons: React.FC<IBuilderCallReasonsProps> = ({ contactsButton, flatViewOrderButton }) => {
  return (
    <Layout>
      <div className={styles['builder-call-reasons']} data-testid="BuilderCallReasons">
        <div className={styles['content']}>
          <UIHeading1>Спросите у застройщика</UIHeading1>
          <div className={styles['reasons']} data-testid="BuilderCallReasonList">
            {QUESTIONS.map((question, index) => (
              <div key={index} className={styles['reason']}>
                {question}
              </div>
            ))}
          </div>
          <div className={styles['actions']}>
            {contactsButton}
            {flatViewOrderButton}
          </div>
        </div>
        <div className={styles['image']} />
      </div>
    </Layout>
  );
};
